import TYPES from '../../types';

// Domain
import { DocumentTypeEntity } from '../../domain/entities/document-type-entity';
import { DocumentTypeRepository } from '../../domain/repository/document-type-repository';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchDocumentTypesQuery extends Query<Promise<Array<DocumentTypeEntity>>> {
  @Inject(TYPES.CATALOG_ALLIANZ_DOCUMENT_TYPE_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.CATALOG_ALLIANZ_DOCUMENT_TYPE_REPOSITORY)
  private readonly repository!: DocumentTypeRepository;

  internalExecute(): Promise<Array<DocumentTypeEntity>> {
    return new Promise((resolve, reject) => {
      if (!this.state_manager.state.loaded) {
        this.repository.execute()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
